'use strict';

let env = {
  $window: window,
  $html: document.getElementsByTagName('html')[0],
  $mainContent: document.getElementById('barba-wrapper'),
  $body: document.body,
  $master: document.getElementById('master'),
  $mainnav: document.getElementById('mainnav-view'),
  $mainTransition: document.getElementById('jsView--transition'),
  $launcher: document.getElementById('jsLauncher'),
  framework: {},
  tablet: false,
  mobile: false,
  phone: false,
  desktop: false,
  ios: false,
  ie11: false,
  edge: false,
  orientation: false,
  isVisiting: false,
  isOldie: false,
  isTouch: 'ontouchstart' in window,
};

export default env;
